// extracted by mini-css-extract-plugin
export var bounce = "_jp-1";
export var generatingText = "_jp-6";
export var lightning = "_jp-4";
export var popup = "_jp-5";
export var progressBar = "_jp-7";
export var progressFill = "_jp-8";
export var progressShimmer = "_jp-9";
export var progressText = "_jp-a";
export var shimmer = "_jp-3";
export var uploadIcon = "_jp-0";
export var uploadingText = "_jp-2";